import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgCheckBadge = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 20,
	height: 20,
	fill: "none",
	viewBox: "0 0 20 20",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [title ? /* @__PURE__ */ _jsx("title", {
		id: titleId,
		children: title
	}) : null, /* @__PURE__ */ _jsx("path", {
		stroke: "currentColor",
		strokeLinecap: "round",
		strokeLinejoin: "round",
		strokeMiterlimit: 10,
		strokeWidth: 1.5,
		d: "m6.75 10.75 1.75 1.5 4.75-4.5m-3.252 9.5-2.498.5-1.75-2-2.5-1L3.246 12 1.75 9.998l1.496-2.196.004-2.552 2.5-.998L7.5 2.25 9.998 3l2.5-.75 1.75 2.002 2.5.998.004 2.552 1.496 2.196L16.752 12l-.004 2.75-2.5 1-1.75 2-2.5-.5Z"
	})]
});
const ForwardRef = forwardRef(SvgCheckBadge);
export { ForwardRef as ReactComponent };
